const TextArea = ({
  className,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  name,
  title,
  error,
  inputStyles,
}: {
  className?: string;
  placeholder: string;
  value?: string;
  disabled?: boolean;
  name: string;
  title?: string;
  inputStyles?:string;
  error?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && event.shiftKey) {
      event.preventDefault();
      const target = event.target as HTMLTextAreaElement;
      const currentValue = target.value;
      const cursorPosition = target.selectionStart;
      const newValue = currentValue.substring(0, cursorPosition) + '\n' + currentValue.substring(cursorPosition);

      if (onChange) {
        onChange({ ...event, target: { ...target, value: newValue } } as React.ChangeEvent<HTMLTextAreaElement>);
      }

      setTimeout(() => {
        target.selectionStart = target.selectionEnd = cursorPosition + 1;
      }, 0);
    }
  };

  return (
    <div className={`space-y-2 relative font-medium ${className}`}>
      <label htmlFor={name} className="text-sm font-semibold text-textPrimary">
        {title}
      </label>
      <textarea
        className={`block w-full resize-none rounded-xl border border-[#d8e0df] bg-[#f8faf9] p-4 text-sm font-medium text-textPrimary placeholder:text-lightGray/70 transition-all duration-200 hover:border-secondary/50 focus:border-secondary focus:bg-white focus:outline-none focus:ring-4 focus:ring-secondary/10 ${error ? "border-red-600 focus:border-red-600 focus:ring-red-600/10" : ""} ${inputStyles}`}
        placeholder={placeholder}
        value={value}
        name={name}
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
        rows={4} // Set the default row count
        
        onChange={onChange}
        disabled={disabled}
        aria-invalid={!!error}
      />
      {error && <span className="text-xs font-semibold text-red-600">{error}</span>}
    </div>
  );
};

export default TextArea;
